export const SHOPIFY_PRODUCT_PRICE_SYNC_FIELDS_LIST: any = [
    {
        attribute: "id",
        label: "Id",
        cssClass: ''
    },
    {
        attribute: "status",
        label: "Status",
        cssClass: 'text-center'
    },
    {
        attribute: "total",
        label: "Total",
        cssClass: 'text-center'
    },
    {
        attribute: "createdAt",
        label: "Created At",
        cssClass: 'text-center',
        isDate: true
    },
    {
        attribute: "updatedAt",
        label: "Updated At",
        cssClass: 'text-center',
        isDate: true
    },
];

export const SHOPIFY_PRODUCTS_PRICE_FIELDS_LIST: any = [
    {
        attribute: "title",
        label: "Title",
        cssClass: 'w-96 font-semibold',
        isTitle: true,
        otherAttributes: ['product_type', 'category']
    },
    {
        attribute: "costRange",
        label: "Cost Range (USD)",
        cssClass: 'text-center text-purple-700 font-bold',
        prefix: '$'
    },
    {
        attribute: "profitPercentage",
        label: "Profit Percentage (USD)",
        cssClass: 'text-center text-green-700 font-bold',
        suffix: '%'
    },
    {
        attribute: "discountPercentage",
        label: "Discount Percentage (USD)",
        cssClass: 'text-center text-red-700 font-bold',
        suffix: '%'
    },
    {
        attribute: "msrpRange",
        label: "MSRP Range (USD)",
        cssClass: 'text-center',
        prefix: '$'
    },
    {
        attribute: "msrpProfitRange",
        label: "MSRP Profit Range (USD)",
        cssClass: 'text-center',
        prefix: '$'
    },
    {
        attribute: "salePriceRange",
        label: "Sale Price Range (USD)",
        cssClass: 'text-center text-blue-700 font-bold',
        prefix: '$'
    },
    {
        attribute: "discountAmountRange",
        label: "Discount Amount Range (USD)",
        cssClass: 'text-center text-gray-700 font-bold',
        prefix: '$'
    },
    {
        attribute: "saleProfitRange",
        label: "Sale Profit Range (USD)",
        cssClass: 'text-center text-green-700 font-bold',
        prefix: '$'
    }
];


export const SHOPIFY_PRODUCT_PRICE_SYNC_INPUT_FIELDS: any = [
    {
        attribute: "productId",
        label: "Product Id",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "title",
        label: "Title",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "productType",
        label: "Product Type",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "category",
        label: "Category",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "profitPercentage",
        label: "Profit Percentage",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "discountPercentage",
        label: "Discount Percentage",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "costRange",
        label: "Cost Range",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "msrpRange",
        label: "MSRP Range",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "msrpProfitRange",
        label: "MSRP Profit Range",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "salePriceRange",
        label: "Sale Price Range",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "saleProfitRange",
        label: "Sale Profit Range",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
    {
        attribute: "discountAmount",
        label: "Discount Amount",
        type: 'text',
        group: 'detail',
        cssClass: ''
    },
];
